import type {
    IKeywordsQueryBarProps,
    IKeywordGroup,
    QueryBarItemMode,
} from "app/components/compare/KeywordsQueryBar/KeywordsQueryBarTypes";

const USER_CATEGORIES = 0;
const SHARED_CATEGORIES = 1;

export const findSelectedKeywordGroup = (keywordGroups: IKeywordGroup[], selectedGroupId: string): IKeywordGroup => {
    if (!selectedGroupId) {
        return null;
    }

    return keywordGroups?.find((group) => group.id === selectedGroupId);
};

export const adaptKeywordsQueryBarProps = (categoriesProps: {
    customCategories: any[];
    selectedCat: string;
    mode: QueryBarItemMode;
    searchTerm?: string;
    isLoading?: boolean;
    keywordGroupId?: string;
}): IKeywordsQueryBarProps => {
    const { customCategories, selectedCat, searchTerm, mode, isLoading = false, keywordGroupId } = categoriesProps;

    const userCategories: IKeywordGroup[] =
        customCategories?.[USER_CATEGORIES]?.map((cat) => {
            return {
                id: cat.id || cat.Id,
                text: cat.text || cat.Name,
                isShared: false,
                keywords: cat.domains || cat.Keywords,
            };
        }) ?? [];

    const sharedCategories: IKeywordGroup[] =
        customCategories?.[SHARED_CATEGORIES]?.map((cat) => {
            return {
                id: cat.id || cat.Id,
                text: cat.text || cat.Name,
                isShared: true,
                keywords: cat.domains || cat.Keywords,
            };
        }) ?? [];

    return {
        keywordGroups: [...userCategories, ...sharedCategories],
        mode: mode,
        selectedKeywordGroupId: selectedCat || keywordGroupId,
        selectedKeyword: searchTerm || `*${keywordGroupId}`,
        isLoading: isLoading,
    };
};
